export default "__VITE_ASSET__D2p9hkiS__"